import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { GrundstueckTypAuswahl, GrundstueckTypAuswahlMeta } from '../../../core/gb-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { CapFormRowDirective } from '../../form-control/cap-form-row.directive';
import SucheSdrUnterartEnum = GrundstueckTypAuswahl.SucheSdrUnterartEnum;

@Component({
  selector: 'cap-grundstuecktype-selection',
  templateUrl: './grundstuecktype-selection.component.html',
  styleUrls: ['./grundstuecktype-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GrundstueckSelectionComponent),
      multi: true
    }
  ],
  imports: [CapFormControlComponent, FormsModule, MetaDisablerDirective, MetaValidatorDirective, CapFormRowDirective, TranslatePipe]
})
export class GrundstueckSelectionComponent implements ControlValueAccessor {
  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @Input() heading = 'Grundstuecksart';

  @Input() folioSucheMoeglich = true;
  @Input() stwSucheMoeglich = true;
  @Input() mitSucheMoeglich = true;

  model: GrundstueckTypAuswahlMeta;
  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  sdrUnterartArray: SucheSdrUnterartEnum[] = [null, 'BAURECHT', 'KONZESSION', 'QUELLENRECHT', 'UEBRIGES_RECHT'];
  sucheSdrUnterartEnum = SucheSdrUnterartEnum;

  constructor(private translate: TranslateService) {
    keysToTranslate<string>(['Folio']);
  }

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  getUnterart(value: SucheSdrUnterartEnum | null) {
    if (!value) {
      return '';
    }
    return this.translate.instant(value);
  }
}
